/**
 * Created by evgenijsenkevic on 26.12.2024
 */
const FriendsListRequestsToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.FRIENDS_LIST_REQUESTS);

    this.enable();
};

FriendsListRequestsToolbarItem.prototype = Object.create(ToolbarItem.prototype);
FriendsListRequestsToolbarItem.prototype.constructor = FriendsListRequestsToolbarItem;

FriendsListRequestsToolbarItem.prototype.isVisible = function () {
    return levels.user.checkAvailable(cleverapps.config.availables.FRIENDBALLOON);
};

FriendsListRequestsToolbarItem.prototype.onClick = function () {
    this.unmark();

    cleverapps.tutorial.trigger("send_gift_for_friends");

    cleverapps.metrics.logEvent(cleverapps.EVENTS.SELECT_FRIEND_ICON_PRESSED);

    const userId = connector.platform.getUserID();

    cleverapps.focusManager.display({
        focus: "FriendsSendPresentWindow",
        action: function (f) {
            const player = new ActionPlayer([
                Friends.loadFriends,

                (f) => {
                    SelectFriendWindow.CreateAndSendRequest("sendGift", {
                        push_code: "friend_balloon",
                        friendId: userId,
                        request_type: levels.FriendRequest.TYPE_SENT_UNIT,
                        id: `${Date.now().toString(36) + Math.random().toString(36).slice(2, 5)}`
                    }, (code, friends) => {
                        if (code === cleverapps.CODE_SUCCEED) {
                            cleverapps.metrics.logEvent(cleverapps.EVENTS.SELECT_FRIEND_SUCCESS);
                            friends.forEach((friend) => {
                                levels.FriendRequests.sendGift(friend);
                            });
                        } else if (code === cleverapps.CODE_FAILED) {
                            cleverapps.notification.create(Messages.get("FriendGift.error"));
                            cleverapps.metrics.logEvent(cleverapps.EVENTS.SELECT_FRIEND_FAILED);
                        } else {
                            cleverapps.metrics.logEvent(cleverapps.EVENTS.SELECT_FRIEND_CANCEL);
                        }

                        f();
                    });
                }
            ]);
            player.onComplete(f);
            player.play();
        }
    });
};
